import { Component, createRef } from "react";
import "./History.css";
import { AiOutlineDelete } from "react-icons/ai";

class History extends Component {
    constructor(props) {
        super(props);
        this.scollToRef = createRef();
    }

    handleLoadMore = () => {
        this.props.getImages(this.props.images.slice(-1)[0]._id);
        setTimeout(() => {
            this.scollToRef.current.scrollIntoView();
        }, 500)

    }

    render() {
        const images = [...this.props.images];

        return (

            <div className="history">
                <div className="divider-history">Image History</div>
                <div className='grid-history'>
                    {images.map((value, index) =>
                        <div className="item-history" key={index} >
                            <img
                                className="img-history"
                                src={("imageHashTn" in value) ? value.imageHashTn : value.imageHash}
                                alt="GeneratedImage"
                                width={"100%"}
                                height={"auto"}
                                onClick={this.props.handleGalerySelection.bind(this, value)}
                            />
                            <div className="hover-image">
                                <AiOutlineDelete onClick={this.props.handleDeleteImages.bind(this, value._id)} />
                            </div>
                        </div>
                    )}
                    <div ref={this.scollToRef}>A</div>
                </div>


                {this.props.totalImages > images.length &&
                    <div style={{ textAlign: "center" }}>
                        <button
                            disabled={this.props.totalImages <= images.length}
                            className="button-load-history"
                            onClick={this.handleLoadMore}
                        >Load more</button>
                    </div>
                }
            </div>
        );
    }
}

export default History;